import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class IllustrationsAnim {
  constructor(section) {
    this.section = section;
		this.title = this.section.querySelector(".panel-title");
		this.text = this.section.querySelector(".description");
		this.eras = this.section.querySelector(".era-intro");
		
		this.init();
  }

  init() {
		document.fonts.ready.then(() => {
			this.titleSplit = SplitText.create(this.title, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });
			this.textSplit = SplitText.create(this.text, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });

			this.tl = gsap.timeline({ 
				scrollTrigger: {
					trigger: this.section,
					start: "top 50%",
					once: true,
				},
				defaults: {ease: "expo.out", force3D: true},
				onComplete: () => {
					this.titleSplit.revert();
					this.textSplit.revert();
				}
			});

			this.tl
				.set([this.title, this.text], {autoAlpha: 1}, 0)
				.to(this.eras, {autoAlpha: 1, duration: 1.5}, 0)
				.from(this.titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 1.5, stagger: 0.1 }, 0)
				.from(this.textSplit.lines, { yPercent: 100, autoAlpha: 0, duration: 1.4, stagger: 0.1 }, "<5%");
		});

		return this.tl;
  }
}